import { render, staticRenderFns } from "./addNewItem.vue?vue&type=template&id=013a93af&scoped=true&"
import script from "./addNewItem.vue?vue&type=script&lang=js&"
export * from "./addNewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a93af",
  null
  
)

export default component.exports